module.exports = __webpack_public_path__ + "img/join_a_table.866b766e.svg";